import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Ng1StateProxy } from "@gtmhub/core/routing";
import { Link, LinkSpecDetail } from "@webapp/links/models/links.models";

import { IRelatedLinkOptions, IRelatedItem, IUpdateLinkArgs } from "@webapp/links/models/related-items.models";
import { hasCurrentUserRole } from "@gtmhub/users";

// TODO: Localize label
const relatedLinkOptions: IRelatedLinkOptions[] = [
  {
    linkType: "relating",
    label: "relates to",
  },
  {
    linkType: "related",
    label: "relates to",
  },
  {
    linkType: "supporting",
    label: "supports",
  },
  {
    linkType: "supported",
    label: "supported by",
  },
  {
    linkType: "blocking",
    label: "blocks",
  },
  {
    linkType: "blocked",
    label: "blocked by",
  },
  {
    linkType: "preceding",
    label: "precedes",
  },
  {
    linkType: "preceded",
    label: "continuation of",
  },
];

@Component({
  selector: "related-item-row",
  templateUrl: "./related-item-row.component.html",
  styleUrls: ["./related-item-row.component.less"],
})
export class RelatedItemRowComponent implements OnInit {
  @Input() public relatedItem: IRelatedItem;
  @Output() private deleteRelatedItem = new EventEmitter<IRelatedItem>();
  @Output() private updateLinkOption = new EventEmitter<IUpdateLinkArgs>();

  public relatedLinkOptions: IRelatedLinkOptions[] = relatedLinkOptions;
  public hasViewOnlyRole: boolean;
  private linkTypeToDelete: Link;

  constructor(private ng1StateProxy: Ng1StateProxy) {}

  public ngOnInit(): void {
    this.linkTypeToDelete = this.relatedItem.linkType;
    this.hasViewOnlyRole = hasCurrentUserRole("view-only");
  }

  public onUpdateLinkOption(): void {
    const args: IUpdateLinkArgs = { linkTypeToDelete: this.linkTypeToDelete, relatedItem: this.relatedItem };
    this.updateLinkOption.emit(args);
    this.linkTypeToDelete = this.relatedItem.linkType;
  }

  public onDeleteItem(): void {
    this.deleteRelatedItem.emit(this.relatedItem);
  }

  public openRelatedItem(relatedItem: IRelatedItem): void {
    const type: LinkSpecDetail = relatedItem.iconType;
    type === "goal"
      ? this.ng1StateProxy.go("gtmhub.goals.all._goalSidebar.goal", { id: relatedItem.id })
      : this.ng1StateProxy.go("gtmhub.goals.all._metric.metric", { metricId: relatedItem.id });
  }
}
